export class CONST {}
export default CONST;

export namespace CONST.SELSMAN.PERMISTION {
  export const PENDING = '招待中';
  export const ALIVE = '承認済';
  export const LOCK = '停止';
}

export namespace CONST.ARRAY {
  export const NORMAL = [
    {text: 'なし', value: 0},
  ];
  export const CLIENT_RANK = [
    {text: 'A', value: 1},
    {text: 'B', value: 2},
    {text: 'C', value: 3},
    {text: 'D', value: 4},
  ];
}

export namespace CONST.BOOL {
  export const TRUE = 'true';
}

export namespace CONST.MODE {
  export const SELECT = 'select';
  export const EDIT = 'edit';
  export const NORMAL = 'normal';
  export const NEW = 'new';
}


export namespace CONST.ROLE {
  export const ADMIN = 1;
  export const NORMAL = 2;
}
